import React from "react";
import PropTypes from "prop-types"
import {Table} from 'antd';
import {defaultPagination} from "../../util/Util"

const PersonCustomerSelectionTable = ({ dataSource, loading}) => {
    const columns = [
        {
            title: 'Client selection that the person is in',
            dataIndex: 'selectionName',
            width:180
        },
        {
            title: 'Client Specific Person ID in client system',
            dataIndex: 'customerPersonId',
            width: 180
        }
    ];

    return (
        <Table
            dataSource={dataSource}
            loading={loading}
            columns={columns}
            size="small"
            bordered
            pagination={defaultPagination()}
    />)
};

PersonCustomerSelectionTable.propTypes = {
    dataSource: PropTypes.array.isRequired,
    onSelectChange: PropTypes.func,
    loading: PropTypes.bool.isRequired
};

export default PersonCustomerSelectionTable



// WEBPACK FOOTER //
// ./src/js/browse/person/PersonCustomerSelectionTable.js